export default "__VITE_ASSET__dOZdYKn6__"